import { render, staticRenderFns } from "./project-list-management.html?vue&type=template&id=19fcedd6&"
import script from "./ProjectListManagement.vue?vue&type=script&lang=js&"
export * from "./ProjectListManagement.vue?vue&type=script&lang=js&"
import style0 from "./ProjectListManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports